<template>
  <label class="block md:mr-2">
    <span
      class="inline-block text-shade-900 font-semibold first-letter:uppercase"
    >
      {{ label }}
    </span>
    <input
      type="text"
      :value="internalValue"
      @input="onInput"
      :placeholder="placeholder"
      class="mt-1 block w-full border hover:border-primary-400 border-shade-900 outline-none ring-2 ring-transparent placeholder:text-shade-400 focus:border-transparent focus:ring-2 focus:ring-primary-400"
    />
  </label>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue'])

const internalValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newValue) => {
    internalValue.value = newValue ?? ''
  }
)

function onInput(event: Event) {
  const value = (event.target as HTMLInputElement).value
  internalValue.value = value
  emit('update:modelValue', value)
}
</script>
